var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WaterfallChart',{attrs:{"hcTitle":_vm.hcTitle,"hcSubtitle":"Appraisal Value","hcData":_vm.hcData}})}
var staticRenderFns = []

export { render, staticRenderFns }